import {Close} from "@material-ui/icons"
import React from "react"
import {Modal} from "react-bootstrap"
import {AvantModalCloseIcon} from "../../app/generic-components/AvantModalCloseIcon"
import {theme} from "../../styles/MuiThemes"
import {STAMP_4S_PRODUCT_ID, STAMP_4SE_PRODUCT_ID,STAMP_SIGN_LANGUAGE_PRODUCT_ID,RECEPTIVE,
    LISTENING_ASL_RECEPTIVE,
    EXPRESSIVE,NOELLA_IMAGES, IMAGES_BASE_URL} from "../../util/Constants"
import {ProductId} from "../../validation/ValidPrimaryKey"
import Button from "../Button/Button"

interface StartTestModalProps {
    showModal: boolean
    currentTestName: string
    closeModal: () => void
    startPanel: () => void
    productId: ProductId
}

export default class StartTestModal extends React.Component<StartTestModalProps, {}> {
    constructor(props: StartTestModalProps) {
        super(props)
        this.state = {
            showModal: props.showModal,
            currentTestName: props.currentTestName
        }
    }

    closeModal = () => {
        this.props.closeModal()
    }

    handleYes = () => {
        this.props.startPanel()
    }

    render() {
        const {showModal, currentTestName, productId} = this.props

        let imageUrl = `${IMAGES_BASE_URL}${currentTestName}.svg`
        let imageClass = "start-test-modal__content__image"
        if (productId.value() === STAMP_4SE_PRODUCT_ID.value()) {
            const baseUrl = NOELLA_IMAGES
            imageUrl = `${baseUrl}${currentTestName.toLowerCase()}_small.jpg`
            imageClass = `${imageClass} start-test-modal__content__image--4se`
        }

        // I've refactored this function to display the Listening/ASL Receptive image when the section is a
        // Listening section and the test is a 4s test. This is a temporary change and will be removed later.
        if (currentTestName === "Listening" && this.props.productId.value() === STAMP_4S_PRODUCT_ID.value()) {
            imageUrl = LISTENING_ASL_RECEPTIVE
        }
        else if (currentTestName === "Listening" && this.props.productId.value() === STAMP_SIGN_LANGUAGE_PRODUCT_ID.value()) {
            imageUrl = RECEPTIVE
        } else if (currentTestName === "Speaking" && this.props.productId.value() === STAMP_SIGN_LANGUAGE_PRODUCT_ID.value()) {
            imageUrl = EXPRESSIVE
         }else{}


        return (
            <Modal className="start-test-modal" show={showModal} onHide={this.closeModal}>
                <Modal.Header closeButton={false} style={{justifyContent: "center", alignItems: "center", padding: theme.spacing(3)}}>
                        {/*The conditional statement below renders "Start the Listening/ASL Receptive Section?" when
                        the skill is listening and the exam is a 4s exam. This is a temporary change and will be
                        reversed later.*/}
                        {currentTestName === "Listening" && this.props.productId.value() === STAMP_4S_PRODUCT_ID.value()
                            ? (
                                <Modal.Title data-tst-id={"start-test-modal-title"}>
                                    Start the Listening/ASL Receptive Section?
                                </Modal.Title>
                            )
                            : currentTestName === "Listening" && this.props.productId.value() === STAMP_SIGN_LANGUAGE_PRODUCT_ID.value()
                            ? (
                                <Modal.Title data-tst-id={"start-test-modal-title"}>
                                    Start the Receptive Section?
                                </Modal.Title>
                            )
                            : currentTestName === "Speaking" && this.props.productId.value() === STAMP_SIGN_LANGUAGE_PRODUCT_ID.value()
                            ? (
                                <Modal.Title data-tst-id={"start-test-modal-title"}>
                                    Start the Expressive Section?
                                </Modal.Title>
                            )
                            : 
                            (
                                <Modal.Title data-tst-id={"start-test-modal-title"}>
                                    {`Start the ${currentTestName} Section?`}
                                </Modal.Title>
                            )
                        }
                    <AvantModalCloseIcon
                        onClick={this.closeModal}
                    >
                        <Close/>
                    </AvantModalCloseIcon>
                </Modal.Header>
                <Modal.Body>
                    <div className="start-test-modal__content">
                        <div className={imageClass}>
                            <img src={imageUrl} alt=""/>
                        </div>
                        <div>
                            {/*The conditional statement below renders "listening/ASL receptive" when the skill is listening
                            and the exam is a 4s exam. This is a temporary change and will be reversed later.*/}
                            {currentTestName === "Listening" && this.props.productId.value() === STAMP_4S_PRODUCT_ID.value()
                                ? (
                                    <p
                                        className="start-test-modal__content__text"
                                        data-tst-id="start-test-modal-content"
                                    >
                                        {"You have selected the "}
                                        <b>listening/ASL receptive</b>
                                        {" section of the test. Are you sure you want to continue?"}
                                    </p>
                                )
                                : currentTestName === "Listening" && this.props.productId.value() === STAMP_SIGN_LANGUAGE_PRODUCT_ID.value()
                                ? (
                                    <p
                                        className="start-test-modal__content__text"
                                        data-tst-id="start-test-modal-content"
                                    >
                                        {"You have selected the "}
                                        <b>receptive</b>
                                        {" section of the test. Are you sure you want to continue?"}
                                    </p>
                                )
                                :currentTestName === "Speaking" && this.props.productId.value() === STAMP_SIGN_LANGUAGE_PRODUCT_ID.value()
                                ? (
                                    <p
                                        className="start-test-modal__content__text"
                                        data-tst-id="start-test-modal-content"
                                    >
                                        {"You have selected the "}
                                        <b>expressive</b>
                                        {" section of the test. Are you sure you want to continue?"}
                                    </p>
                                )
                                :(
                                    <p
                                        className="start-test-modal__content__text"
                                        data-tst-id="start-test-modal-content"
                                    >
                                        {"You have selected the "}
                                        <b>{currentTestName.toLowerCase()}</b>
                                        {" section of the test. Are you sure you want to continue?"}
                                    </p>
                                )
                            }
                            <div className="start-test-modal__content__buttons">
                                <Button
                                    className="avant-button--primary start-test-modal__content__buttons__button"
                                    block={true}
                                    testId="modal-yes-button"
                                    onClick={this.handleYes}
                                >
                                    YES
                                </Button>
                                <Button
                                    className="avant-button--link start-test-modal__content__buttons__button"
                                    block={true}
                                    testId="modal-no-button"
                                    onClick={this.closeModal}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}
